<template>
  <div class="spinner" />
</template>

<script setup lang="ts">
defineOptions({
  name: "spinner",
});
</script>

<style lang="scss">
@import "./index.scss";
</style>
